Ext.ns('mx.comp');

mx.comp.SingleRowSelectionModel = function(config) {
    Ext.apply(this, config);
    this.addEvents(
        /**
         * @event beforeMouseDown
         * Fires when a row is being clicked by mouse down
         * @param {SelectionModel} this
         * @param {Number} rowIndex
         * @param {Event} e
         */
        'beforeMouseDown'
    );

    Ext.grid.SingleRowSelectionModel.superclass.constructor.call(this);
};

mx.comp.SingleRowSelectionModel = Ext.extend(Ext.grid.RowSelectionModel, {
    singleSelect: true,
    handleMouseDown: function(g, rowIndex, e) {
        var t = e.getTarget('table.x-grid3-row-table');
        var row = g.view.getRow(rowIndex);
        if (t && row && row.firstChild == t && this.fireEvent('beforeMouseDown', this, rowIndex, e) !== false) {
            e.ctrlKey = true; // emulate ctrl-click to deselect row if selected
            mx.comp.SingleRowSelectionModel.superclass.handleMouseDown.apply(this, arguments);
        }
    },
    focus: function() {
        this.grid.getView().focusRow(this.lastActive);
    },
    initEvents: function() {
        if (!this.grid.enableDragDrop && !this.grid.enableDrag) {
            this.grid.on('rowmousedown', this.handleMouseDown, this);
        } else {
            // allow click to work like normal
            this.grid.on(
                'rowclick',
                function(grid, rowIndex, e) {
                    if (e.button === 0 && !e.shiftKey && !e.ctrlKey) {
                        this.selectRow(rowIndex, false);
                        grid.view.focusRow(rowIndex);
                    }
                },
                this
            );
        }

        /*this.rowNav = new Ext.KeyNav(this.grid.getGridEl(), {
            "up" : function(e) {
                if (e.ctrlKey) {
                    if (!e.shiftKey) {
                        this.selectPrevious(e.shiftKey);
                    } else if (this.last !== false && this.lastActive !== false) {
                        var last = this.last;
                        this.selectRange(this.last, this.lastActive - 1);
                        this.focus();
                        if (last !== false) {
                            this.last = last;
                        }
                    } else {
                        this.selectFirstRow();
                    }
                }
            },
            "down" : function(e) {
                if (e.ctrlKey) {
                    if (!e.shiftKey) {
                        this.selectNext(e.shiftKey);
                    } else if (this.last !== false && this.lastActive !== false) {
                        var last = this.last;
                        this.selectRange(this.last, this.lastActive + 1);
                        this.grid.getView().focusRow(this.lastActive);
                        if (last !== false) {
                            this.last = last;
                        }
                    } else {
                        this.selectFirstRow();
                    }
                }
            },
            scope: this
        });*/

        var view = this.grid.view;
        view.on('refresh', this.onRefresh, this);
        view.on('rowupdated', this.onRowUpdated, this);
        view.on('rowremoved', this.onRemove, this);
    },
});
